import { render, staticRenderFns } from "./ProductSuggestForEdit.vue?vue&type=template&id=7e5d679f"
import script from "./ProductSuggestForEdit.vue?vue&type=script&lang=js"
export * from "./ProductSuggestForEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports